import React from "react";
import { Typography, Divider, List, Card } from "antd";
import { StyledPrivacyPolicy } from "../PrivacyPolicy/styles";
import { APP_EMAIL } from "../../../utils/AiService/constant";

const { Title, Paragraph, Text } = Typography;

const TermsOfService = () => {
  return (
    <StyledPrivacyPolicy>
      <div className="privacy-container">
        <Card className="privacy-card">
          <Title level={2} className="privacy-title">
            Terms of Service
          </Title>
          <Text className="last-updated">Last updated: February 2026</Text>

          <Divider />

          {/* AGREEMENT */}
          <section className="privacy-section">
            <Title level={4}>1. AGREEMENT</Title>
            <Paragraph>
              By using Kelu, you agree to these terms. If you don't agree,
              please don't use our service.
            </Paragraph>
            <Paragraph>
              These terms form a contract between you and Kelu , a company
              registered in England and Wales.
            </Paragraph>
          </section>

          {/* THE SERVICE */}
          <section className="privacy-section">
            <Title level={4}>2. THE SERVICE</Title>
            <Paragraph>
              Kelu provides a secure business messaging platform for
              professional services businesses.
            </Paragraph>
            <Paragraph>We reserve the right to:</Paragraph>
            <List
              dataSource={[
                "Modify or discontinue features",
                "Update pricing with 30 days notice",
                "Suspend accounts that violate these terms",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* YOUR ACCOUNT */}
          <section className="privacy-section">
            <Title level={4}>3. YOUR ACCOUNT</Title>
            <Paragraph>You are responsible for:</Paragraph>
            <List
              dataSource={[
                "Keeping your login credentials secure",
                "All activity under your account",
                "Ensuring your team follows these terms",
                "Providing accurate account information",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* ACCEPTABLE USE */}
          <section className="privacy-section">
            <Title level={4}>4. ACCEPTABLE USE</Title>
            <Paragraph>You must NOT use Kelu to:</Paragraph>
            <List
              dataSource={[
                "Send spam or unsolicited messages",
                "Harass, abuse, or harm others",
                "Share illegal content",
                "Violate any applicable laws",
                "Attempt to breach our security",
                "Resell or sublicense the service without permission",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* DATA & PRIVACY */}
          <section className="privacy-section">
            <Title level={4}>5. DATA & PRIVACY</Title>
            <List
              dataSource={[
                "You own your data",
                "We process it only to provide the service",
                "See our Privacy Policy for full details",
                "You are responsible for your customers' data and obtaining their consent",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* PAYMENT TERMS */}
          <section className="privacy-section">
            <Title level={4}>6. PAYMENT TERMS</Title>
            <List
              dataSource={[
                "Subscriptions are billed monthly or annually in advance",
                "All prices in GBP (£) unless stated",
                "No refunds for partial months",
                "14-day free trial, no credit card required",
                "We may change pricing with 30 days notice",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* CANCELLATION */}
          <section className="privacy-section">
            <Title level={4}>7. CANCELLATION</Title>
            <List
              dataSource={[
                "Cancel anytime from your account settings",
                "Access continues until end of billing period",
                "Data available for export for 30 days after cancellation",
                "After 30 days, data is permanently deleted",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* GDPR & COMPLIANCE */}
          <section className="privacy-section">
            <Title level={4}>8. GDPR & COMPLIANCE</Title>
            <Paragraph>You agree to:</Paragraph>
            <List
              dataSource={[
                "Use Kelu in compliance with UK GDPR",
                "Obtain necessary consents from your customers",
                "Not store sensitive personal data beyond what's needed",
                "Report any data breaches to us immediately",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* INTELLECTUAL PROPERTY */}
          <section className="privacy-section">
            <Title level={4}>9. INTELLECTUAL PROPERTY</Title>
            <List
              dataSource={[
                "Kelu owns all platform code, design, and branding",
                "You own all content you create on the platform",
                "You grant us licence to process your content to provide the service",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* LIABILITY */}
          <section className="privacy-section">
            <Title level={4}>10. LIABILITY</Title>
            <List
              dataSource={[
                'We provide the service "as is"',
                "We're not liable for indirect or consequential losses",
                "Our total liability is limited to fees paid in the last 3 months",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* GOVERNING LAW */}
          <section className="privacy-section">
            <Title level={4}>11. GOVERNING LAW</Title>
            <Paragraph>
              These terms are governed by the laws of England and Wales.
              Disputes will be resolved in English courts.
            </Paragraph>
          </section>

          {/* CHANGES */}
          <section className="privacy-section">
            <Title level={4}>12. CHANGES</Title>
            <Paragraph>
              We may update these terms with 30 days notice by email. Continued
              use means acceptance.
            </Paragraph>
          </section>

          <Divider />
          <Paragraph>ico.org.uk | 0303 123 1113</Paragraph>
          <Paragraph>
            Questions? Email: <strong>{APP_EMAIL}</strong>
          </Paragraph>
        </Card>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default TermsOfService;
